export default __webpack_public_path__ + "fe4f665aa6cefbb8e6288965bf4c3a2e.png";